import { searchAddressList } from "@services";
import { addressRoutes, statusEnum } from "@services";
import { AddressApiResponse } from "@interface";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const searchPropertyAddress = createAsyncThunk(
    addressRoutes.searchAddress,
    async (text: string, { rejectWithValue }) => {
        try {
            const response = await searchAddressList(text);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const SLICE_NAME = "propertyAddress";

const initialState: AddressApiResponse = {
    data: {
        geocoding: {},
        type: '',
        features: []
    },
    status: statusEnum.idle,
};

export const addressSlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(searchPropertyAddress.pending, (state) => {
                state.status = statusEnum.loading;
            })
            .addCase(searchPropertyAddress.fulfilled, (state, action) => {
                state.status = statusEnum.succeeded;
                state.data = action.payload; // Store the response data
            })
            .addCase(searchPropertyAddress.rejected, (state) => {
                state.status = statusEnum.failed;
            });
    },
});